import React from 'react'
import * as styles from './howWeSupportYou.module.scss'
import SectionWithGrid from 'common/SectionWithGrid'

import Card from 'common/Card'

export default function HowWeSupportYou({ title, grid }) {
  return (
    <SectionWithGrid
      className={styles.section}
      grid={grid}
      title={title}
      titleAs="h3"
      gridItem={(props) => {
        return <Card {...props} hatAs="body2" />
        // return <Card {...props} hat="test" hatAs="body2" />
      }}
      toEdge
      sliderBelow
      swiper={{
        offset: 0.1,
        spaceBetween: 0,
        mobileSpaceBetween: 0,
        mousewheel: true,
      }}
    />
  )
}
